module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Light.07f4dad3.woff2";